import React from "react";
import "./termsofService.scss";
import {Link} from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import AppFooter from "../../../components/appFooter";


export default function TermsofService(props) {
    return (
        <div className={"mainDiv"}>
            <div className="brand-bg-inverse-color mb-3 fancyFont">
                <div className="container">
                    <nav className="navbar navbar-expand-sm navbar-dark brand-bg-inverse-color">
                        <Link to={"/"} className="navbar-brand">
                            <img src={require("../../../assets/logo.png")} alt="" width={"140px"}/>
                        </Link>
                    </nav>
                </div>
            </div>

            <div className="container fancyFont">
                <div className="row">
                    <div className="col-lg-12">
                        <h3 className="h3 brand-text-color inner-header font-regular">TERMS OF SERVICE</h3>
                    </div>

                    <div className="col-lg-12">
                        <p>This page states the “Terms of Use” (“<strong>Terms</strong>”) under which you
                            (“<strong>You</strong>”)
                            may use
                            <a href="http://MemonId.com">MemonId.com</a> (“<strong>MID</strong>”), an on-line service
                            (“<strong>Portal</strong>”) which provides various services such as social interaction with
                            different member
                            Memons around the world, services to post and search employment and business opportunities
                            and user
                            resumes in
                            our database, services in regards to matrimony, and any other service that contributes to
                            the
                            betterment of
                            Memon community globally.</p>
                        <p>The terms and conditions laid down govern our relationship with you. Although we have tried
                            our best
                            to strip
                            the legalese from the Terms, there are places where these Terms may still read like a
                            traditional
                            contract.
                            There’s a good reason for that: These Terms do indeed form a legally binding contract
                            between you
                            and MID. So
                            please read them carefully.</p>
                        <p>By using MID and our other services (“<strong>Services</strong>”) you are indicating your
                            acceptance.
                            And of
                            course on the other hand if you don’t agree then don’t use our Services.</p>
                        <p><strong>Who can use our Services</strong></p>
                        <p>Number one you should be a Memon, secondly children under age 13 without parental guidance/
                            consent
                            are not
                            allowed to register with us. We may offer additional Services with additional terms that may
                            require
                            you to be
                            even older to use them. So please read all terms carefully.</p>
                        <ol>
                            <li>
                                <p>You can form a binding contract with MID.</p>
                            </li>
                            <li>
                                <p>You will comply with these Terms and all applicable local, state, national, and
                                    international
                                    laws, rules,
                                    and regulations.</p>
                            </li>
                        </ol>
                        <p>If you are using the Services on behalf of some other entity, you state that you are
                            authorized to
                            grant all
                            licenses set forth in these Terms and to agree to these Terms on behalf of entity.</p>
                        <p>Terrorists and those who engage in violent crimes are not welcome on <Link
                            to={"http://MemonId.com"}>MemonId.com</Link>.</p>
                        <p><strong>Registration</strong></p>
                        <ul>
                            <li>
                                <p>We expect that you would complete the online registration process with fairness and
                                    honesty
                                    while
                                    furnishing your personal information to MID. You would appreciate that efficient and
                                    effective services
                                    (Ex.- Job opportunities, Matrimonial Services, Any help required within the
                                    community) we
                                    provide through
                                    our automated system depend upon yourself furnishing true, accurate, current,
                                    complete
                                    information and
                                    photos etc. We expect you to read the relevant column before keying in the details
                                    or
                                    selecting the option
                                    available or uploading the photo. You are requested not to key in details of the
                                    profile in
                                    field other than
                                    the applicable field or repeating your details in another field, after filling them
                                    once in
                                    the relevant
                                    fields or others photographs. You further undertake that you alone shall be
                                    responsible or
                                    liable for any
                                    information provided to MID. In order to serve you better if MID requires additional
                                    details
                                    you agree to
                                    provide it. MID shall reproduce the registered member details on “as is as
                                    available” basis
                                    to other
                                    registered members and MID members shall be solely liable for the information given
                                    by such
                                    MID member.</p>
                            </li>
                            <li>
                                <p>If at any point of time MID comes to know or is so informed by any third party or has
                                    reasons
                                    to believe
                                    that any information provided by you for registration (including photos) or
                                    otherwise is
                                    found to be untrue,
                                    inaccurate, or incomplete then MID shall have full right to suspend or terminate
                                    (without
                                    any notice) your
                                    MID membership and refuse to provide MID Service to you thereafter.</p>
                            </li>
                            <li>
                                <p>MID Membership is restricted strictly to the registered MID individual members only.
                                    Organizations,
                                    companies, businesses and/or individuals carrying any kinds of business cannot
                                    become
                                    Members of MID and nor
                                    use the MID Services or MID members data for any commercial purpose, and MID
                                    reserves its
                                    right to initiate
                                    appropriate legal action for breach of these obligation.</p>
                            </li>
                        </ul>
                        <p><strong>Your account</strong></p>
                        <p>You are responsible for any activity that occurs in your MID account. So it’s important that
                            you keep
                            your
                            account secure. One way to do that is to select a strong password that you don’t use for any
                            other
                            account. By
                            using the Services, you agree that, in addition to exercising common sense:</p>
                        <ul>
                            <li>
                                <p>You will not create more than one account for yourself.</p>
                            </li>
                            <li>
                                <p>You will not create another account if we have already disabled your account, unless
                                    you have
                                    our written
                                    permission to do so.</p>
                            </li>
                            <li>
                                <p>You will not buy, sell, rent, or lease access to your MID account username, or a
                                    friend link
                                    without our
                                    written permission.</p>
                            </li>
                            <li>
                                <p>You will not share your password.</p>
                            </li>
                            <li>
                                <p>You will not log in or attempt to access the Services through unauthorized
                                    third-party
                                    applications or
                                    clients.</p>
                            </li>
                        </ul>
                        <p>If you think that someone has gained access to your account, please immediately reach out to
                            MID
                            Support<Link
                                href="#sdfootnote1sym">1</Link>.</p>
                        <p><strong>Rights we grant you</strong></p>
                        <p>MID grants you a personal, worldwide, royalty-free, non-assignable, nonexclusive, revocable,
                            and
                            non-sub
                            licensable license to access and use the Services. This license is for the sole purpose of
                            letting
                            you use and
                            enjoy the Services’ benefits in a way that these Terms and our usage policies allow.</p>
                        <p>Any software that we provide you may automatically download and install upgrades, updates, or
                            other
                            new
                            features. You may be able to adjust these automatic downloads through your device’s
                            settings.</p>
                        <p>You may not copy, modify, distribute, sell, or lease any part of our software, nor may you
                            reverse
                            engineer or
                            attempt to extract the source code of that software, unless laws prohibit these restrictions
                            or you
                            have our
                            written permission to do so.</p>
                        <p><strong>Rights you grant us</strong></p>
                        <p>Many of our Services let you create, upload, post, send, receive, and store content. When you
                            do
                            that, you
                            retain whatever ownership rights in that content you had to begin with. But you grant us a
                            license
                            to use that
                            content. How broad that license is depends on which Services you use and the settings you
                            have
                            selected.</p>
                        <p>The profile data that are set to be viewable by everyone as well as content you submit to
                            crowd-sourced
                            Services, “Public Content.” For all content you submit to the Services other than Public
                            Content,
                            you grant MID
                            and our Affiliates a worldwide, royalty-free, sub licensable, and transferable license to
                            host,
                            store, use,
                            display, reproduce, modify, adapt, edit, publish, and distribute that content. This license
                            is for
                            the limited
                            purpose of operating, developing, providing, promoting, and improving the Services and
                            researching
                            and
                            developing new ones. For the purpose of these Terms, the term “<strong>Affiliates</strong>”
                            shall
                            include the
                            local or regional Memon organizations / associations / jamats having arrangement with MID.
                        </p>
                        <p>Because Public Content is inherently public and chronicles matters of public interest, the
                            license
                            you grant us
                            for this content is broader. In addition to granting us the rights mentioned in the previous
                            paragraph, you also
                            grant us a perpetual license to create derivative works from, promote, exhibit, broadcast,
                            syndicate,
                            sublicense, publicly perform, and publicly display Public Content in any form and in any and
                            all
                            media or
                            distribution methods (now known or later developed). To the extent it’s necessary, when you
                            appear
                            in, create,
                            upload, post, or send Public Content, you also grant MID, our Affiliates, and our business
                            partners
                            the
                            unrestricted, worldwide, perpetual right and license to use your name, likeness, and voice,
                            including in
                            connection with commercial or sponsored content. This means, among other things, that you
                            will not
                            be entitled
                            to any compensation from MID, our Affiliates, or our business partners if your name,
                            likeness, or
                            voice is
                            conveyed through the Services, either on MID application or on one of our business partner’s
                            platforms.</p>
                        <p>For information about how to tailor who can watch your content, please take a look at our
                            Privacy
                            Policy and
                            Support Site.</p>
                        <p>While we’re not required to do so, we may access, review, screen, and delete your content at
                            any time
                            and for
                            any reason, including providing and developing the Services or if we think your content
                            violates
                            these Terms.
                            You alone, though, remain responsible for the content you create, upload, post, send, or
                            store
                            through the
                            Service.</p>
                        <p>The Services may contain advertisements. In consideration for MID letting you access and use
                            the
                            Services, you
                            agree that we, our Affiliates, and our third-party partners may place advertising on the
                            Services.
                            Because the
                            Services contain content that you and other users provide us, advertising may sometimes
                            appear near
                            your
                            content.</p>
                        <p>We always love to hear from our users. But if you volunteer feedback or suggestions, just
                            know that
                            we can use
                            your ideas without compensating you.</p>
                        <p><strong>Content of others</strong></p>
                        <p>Much of the content on our Services is produced by users, publishers, and other third
                            parties.
                            Whether that
                            content is posted publicly or sent privately, the content is the sole responsibility of the
                            person
                            or
                            organization that submitted it. Although MID reserves the right to review or remove all
                            content that
                            appears on
                            the Services, we do not necessarily review all of it. So we cannot and do not take
                            responsibility
                            for any
                            content that others provide through the Services.</p>
                        <p><strong>Use of the MID Services</strong></p>
                        <p>The job posting, resume database, matrimonial services and other features of the Portal may
                            be used
                            only by
                            individuals seeking employment and business opportunities and/or career information/ seeking
                            to get
                            married and
                            by only members of the Memon community. In addition, the Portal may be used by individuals
                            for
                            permitted
                            professional and personal networking purposes and matrimonial services. Your use of the MID
                            Services
                            is also
                            subject to any other contracts you may have with MID. In the case of any conflict between
                            these
                            Terms and any
                            contract you have with MID, the terms of MID contract will prevail.</p>
                        <p><strong>Job posting in MID</strong></p>
                        <p>A Job posting may not contain:</p>
                        <ol>
                            <li>
                                <p>any hyperlinks, other than those specifically authorized by MID;</p>
                            </li>
                            <li>
                                <p>misleading, unreadable, or “hidden” keywords, repeated keywords or keywords that are
                                    irrelevant to the job
                                    opportunity being presented, as determined in MID’s reasonable discretion;</p>
                            </li>
                            <li>
                                <p>the names, logos or trademarks of unaffiliated companies other than those of your
                                    customer
                                    save where
                                    expressly agreed by MID;</p>
                            </li>
                            <li>
                                <p>the names of colleges, cities, states, towns or countries that are unrelated to the
                                    posting;</p>
                            </li>
                            <li>
                                <p>more than one job or job description, more than one location, or more than one job
                                    category,
                                    unless the
                                    product so allows;</p>
                            </li>
                            <li>
                                <p>inaccurate, false, or Misleading information; and</p>
                            </li>
                            <li>
                                <p>material or links to material that exploits people in a sexual, violent or other
                                    manner, or
                                    solicits
                                    personal information from anyone under 18 years.</p>
                            </li>
                            <li>
                                <p>any solicitation for a job from anyone under 18 years.</p>
                            </li>
                        </ol>
                        <p>You may not use Your MID job posting to:</p>
                        <ol>
                            <li>
                                <p>post jobs in a manner that does not comply with applicable local, national and
                                    international
                                    laws,
                                    including but not limited to laws relating to labor and employment, equal employment
                                    opportunity and
                                    employment eligibility requirements, data privacy, data access and use, and
                                    intellectual
                                    property;</p>
                            </li>
                            <li>
                                <p>post jobs that require citizenship of any particular country or lawful permanent
                                    residence in
                                    a country as
                                    a condition of employment, unless otherwise required in order to comply with law,
                                    regulations, executive
                                    order, or federal, state or local government contract;</p>
                            </li>
                            <li>
                                <p>post jobs that include any screening requirement or criterion in connection with a
                                    job
                                    posting where such
                                    requirement or criterion is not an actual and legal requirement of the posted
                                    job;</p>
                            </li>
                            <li>
                                <p>sell, promote or advertise products or services;</p>
                            </li>
                            <li>
                                <p>post any franchise, pyramid scheme, ponzi scheme, chit funds, club membership,
                                    distributorship, multi-level
                                    marketing opportunity, or sales representative agency arrangement;</p>
                            </li>
                            <li>
                                <p>post any business opportunity that requires an upfront or periodic payment or
                                    requires
                                    recruitment of other
                                    members, sub-distributors or sub-agents;</p>
                            </li>
                            <li>
                                <p>post any business opportunity that pays commission only unless the posting clearly
                                    states
                                    that the
                                    available job pays commission only and clearly describes the product or service that
                                    the job
                                    seeker would be
                                    selling;</p>
                            </li>
                            <li>
                                <p>advertise sexual services or seek employees for jobs of a sexual nature;</p>
                            </li>
                            <li>
                                <p>request the use of human body parts or the donation of human parts, including,
                                    without
                                    limitation,
                                    reproductive services such as egg donation and surrogacy;</p>
                            </li>
                            <li>
                                <p>endorse a particular political party, political agenda, political position or
                                    issue;</p>
                            </li>
                            <li>
                                <p>except where allowed by applicable law, post jobs which require the applicant to
                                    provide
                                    information
                                    relating to his/her</p>
                            </li>
                        </ol>
                        <ul>
                            <li>
                                <p>racial or ethnic origin</p>
                            </li>
                            <li>
                                <p>political beliefs</p>
                            </li>
                            <li>
                                <p>membership of a trade union</p>
                            </li>
                            <li>
                                <p>physical or mental health</p>
                            </li>
                            <li>
                                <p>sexual life</p>
                            </li>
                        </ul>
                        <p>MID reserves the right to remove any job or business related posting or content from any
                            Portal,
                            which in the
                            reasonable exercise of MID’s discretion, does not comply with the above.</p>
                        <p>MID reserves the right to remove any content posted on the Portal that MID believes is not in
                            the
                            best interest
                            of MID.</p>
                        <p>If at any time during your use of the MID Services, You made a misrepresentation of fact to
                            MID or
                            otherwise
                            misled MID in regards to the nature of your business activities, MID will have grounds to
                            terminate
                            your use of
                            the MID Services.</p>
                        <p><strong>Resume Database</strong></p>
                        <p>Use of the MID Resume Database by Employers</p>
                        <p>You shall use the MID Resume Database as provided in these Terms and in any contract You have
                            with
                            MID. You
                            shall use the MID Resume Database in accordance with all applicable privacy and data
                            protection
                            laws, and you
                            agree you shall not further disclose any of the data from MID Resume Database to any third
                            party,
                            unless you are
                            an authorized recruitment agency, staffing agency, advertising or other agency or using the
                            resume
                            explicitly
                            for employment purposes.</p>
                        <p>You shall take appropriate physical, technical, and administrative measures to protect the
                            data you
                            have
                            obtained from MID Resume Database from loss, misuse, unauthorized access, disclosure,
                            alteration or
                            destruction.
                            You shall not share Resume Database seat-based license login credentials with any other
                            party, nor
                            share Resume
                            Database pay-per-view license login credentials with any party.</p>
                        <p>The MID Resume Database shall not be used:</p>
                        <ol>
                            <li>
                                <p>for any purpose other than as an employer seeking employees, including but not
                                    limited to
                                    advertising
                                    promotions, products, or services to any resume holders;</p>
                            </li>
                            <li>
                                <p>to make unsolicited phone calls or faxes or send unsolicited mail, email, or
                                    newsletters to
                                    resume holders
                                    or to contact any individual unless they have agreed to be contacted (where consent
                                    is
                                    required or, if
                                    express consent is not required, who has not informed you that they do not want to
                                    be
                                    contacted); or</p>
                            </li>
                            <li>
                                <p>to source candidates or to contact job seekers or resume holders in regards to career
                                    fairs
                                    and business
                                    opportunities prohibited by these Terms of Use.</p>
                            </li>
                        </ol>
                        <p><strong>Matrimonial Services by MID</strong></p>
                        <p>A Matrimonial posting may not contain:</p>
                        <ol>
                            <li>
                                <p>any hyperlinks, other than those specifically authorized by MID;</p>
                            </li>
                            <li>
                                <p>misleading, unreadable, or “hidden” keywords, repeated keywords or keywords that are
                                    irrelevant to the
                                    match being presented, as determined in MID’s reasonable discretion;</p>
                            </li>
                            <li>
                                <p>inaccurate, false, or misleading information; and</p>
                            </li>
                            <li>
                                <p>material or links to material that exploits people in a sexual, violent or other
                                    manner, or
                                    solicits
                                    personal information from anyone under 18 years.</p>
                            </li>
                        </ol>
                        <p><strong>Duties of the Members seeking Matrimonial Services</strong></p>
                        <ol>
                            <li>
                                <p>You have to protect the broader interest of the registered MID member and increase
                                    the
                                    efficiency, MID
                                    members have to ensure to keep their username and password safe and confidential for
                                    using
                                    the MID
                                    services.</p>
                            </li>
                            <li>
                                <p>Any additional information / data required by MID for using the MID services shall be
                                    provided by the MID
                                    Member, as and when so sought by MID.</p>
                            </li>
                            <li>
                                <p>In case partner preference is modified by MID member, then the automated system
                                    generated
                                    prospect search
                                    results in website may also undergo corresponding changes.</p>
                            </li>
                            <li>
                                <p>MID members are requested to exercise due care and caution while short listing the
                                    prospect
                                    and satisfy
                                    themselves before making a choice of your match through adequate efforts,
                                    initiatives and
                                    due diligence. MID
                                    shall not be liable for short coming due to any misrepresentations made by any of
                                    its MID
                                    members.</p>
                            </li>
                            <li>
                                <p>MID members are expected to verify the credentials of the prospect such as family
                                    status,
                                    marital status,
                                    educational qualifications, financial status, occupation, character, health status,
                                    etc.</p>
                            </li>
                            <li>
                                <p>To get better search results, MID Members are expected to provide latest photograph
                                    which
                                    should not more
                                    than 3 months old. Providing old photographs/ photographs of others, inaccurate /
                                    false
                                    information shall be
                                    treated as violation of terms and conditions and MID shall retain their right under
                                    these
                                    terms and
                                    conditions.</p>
                            </li>
                            <li>
                                <p>MID members are expected to disclose their health records during profile enrollment
                                    which
                                    includes any
                                    preexisting illness, physical disability etc. Non- disclosure at the time of
                                    enrollment
                                    shall be treated as
                                    violation of the terms and conditions and MID shall retain their right under these
                                    terms and
                                    conditions.</p>
                            </li>
                            <li>
                                <p>MID Members are expected to refrain from:</p>
                            </li>
                            <li>
                                <p>entering into any financial transactions with prospects.</p>
                            </li>
                            <li>
                                <p>sharing of confidential and personal data with each other but not limited to sharing
                                    of bank
                                    details,
                                    etc.</p>
                            </li>
                            <li>
                                <p>entering into physical relationship with any prospect before marriage.</p>
                            </li>
                            <li>
                                <p>violating any law for the time being in force.</p>
                            </li>
                            <li>
                                <p>mentioning details of other matrimonial services while sending personalized
                                    messages.</p>
                            </li>
                            <li>
                                <p>MID members are expected to visit our privacy policies for understanding the safety
                                    measures
                                    on partner
                                    search and awareness towards online safety.</p>
                            </li>
                            <li>
                                <p>MID members are expected to be cautious of prospects who ask for favors, money etc or
                                    call
                                    from multiple
                                    phone numbers, only interact over phone, doesn’t come forward for face to face
                                    meeting
                                    (physically or
                                    through or through video calls) and don’t involve family and friends in match
                                    making. Beware
                                    of suspended
                                    profiles status before you finalize an alliance with the prospect.</p>
                            </li>
                            <li>
                                <p>You also agree that while accessing / using the Portal, you will be guided by the
                                    terms and
                                    conditions of
                                    the Portal including but not limited to the use of feature of the Portal like chat
                                    instantly
                                    with prospect,
                                    enhancing privacy settings (photo /phone number) or for viewing social and
                                    professional
                                    profile of members
                                    on their Facebook, LinkedIn, etc.</p>
                            </li>
                            <li>
                                <p>MID member shall not assign or transfer your MID membership to any other person or
                                    entity,
                                    and such an act
                                    shall be treated as violation of terms and conditions and MID shall retain their
                                    right under
                                    these terms and
                                    conditions.</p>
                            </li>
                            <li>
                                <p>If the MID member fails to inform MID, about any change in the particulars furnished
                                    by MID
                                    member to other
                                    MID member, then the MID membership may be suspended by MID at its sole
                                    discretion.</p>
                            </li>
                        </ol>
                        <p>In order to ensure a safe and effective experience for all of our members, MID reserves the
                            right to
                            limit the
                            preferences of the matrimonial profile that may be accessed by you in any given time period.
                            These
                            limits may be
                            amended in MID sole discretion from time to time.</p>
                        <p><strong>Respecting your fellow member rights</strong></p>
                        <p>MID respects the rights of others. And so should You. You therefore may not use the Services,
                            or
                            enable anyone
                            else to use the Services, in a manner that:</p>
                        <ol>
                            <li>
                                <p>violates or infringes someone else’s rights of publicity, privacy, copyright,
                                    trademark, or
                                    other
                                    intellectual-property right.</p>
                            </li>
                            <li>
                                <p>bullies, harasses, or intimidates.</p>
                            </li>
                            <li>
                                <p>defames.</p>
                            </li>
                            <li>
                                <p>spam’s or solicits our users.</p>
                            </li>
                        </ol>
                        <p>You must also respect MID’s rights. These Terms do not grant you any right to do any of the
                            following
                            (or
                            enable anyone else to do so):</p>
                        <ol>
                            <li>
                                <p>use branding, logos, designs, photographs, videos, or any other materials used in our
                                    Services.</p>
                            </li>
                            <li>
                                <p>copy, archive, download, upload, distribute, syndicate, broadcast, perform, display,
                                    make
                                    available, or
                                    otherwise use any portion of the Services or the content on the Services except as
                                    set forth
                                    in these
                                    Terms.</p>
                            </li>
                            <li>
                                <p>use the Services, any tools provided by the Services, or any content on the Services
                                    for any
                                    commercial
                                    purposes without our consent.</p>
                            </li>
                        </ol>
                        <p>In short: You may not use the Services or the content on the Services in ways that are not
                            authorized
                            by these
                            Terms. Nor may you help anyone else in doing so.</p>
                        <p><strong>Safety</strong></p>
                        <p>We try hard to keep our Services a safe place for all users. But we can’t guarantee it.
                            That’s where
                            you come
                            in. By using the Services, you agree that:</p>
                        <ol>
                            <li>
                                <p>You will not use the Services for any purpose that is illegal or prohibited in these
                                    Terms.</p>
                            </li>
                            <li>
                                <p>You will not use any robot, spider, crawler, scraper, or other automated means or
                                    interface
                                    to access the
                                    Services or extract other user’s information.</p>
                            </li>
                            <li>
                                <p>You will not use or develop any third-party applications that interact with the
                                    Services or
                                    other users’
                                    content or information without our written consent.</p>
                            </li>
                            <li>
                                <p>You will not use the Services in a way that could interfere with, disrupt, negatively
                                    affect,
                                    or inhibit
                                    other users from fully enjoying the Services, or that could damage, disable,
                                    overburden, or
                                    impair the
                                    functioning of the Services.</p>
                            </li>
                            <li>
                                <p>You will not use or attempt to use another user’s account, username, or password
                                    without
                                    their
                                    permission.</p>
                            </li>
                            <li>
                                <p>You will not solicit login credentials from another user.</p>
                            </li>
                            <li>
                                <p>You will not post content that contains or links to pornography, graphic violence,
                                    threats,
                                    hate speech
                                    like attacking people because of their race, ethnicity, national origin, gender,
                                    sexual
                                    orientation,
                                    political or religious affiliations, or medical or physical condition, or
                                    incitements to
                                    violence.</p>
                            </li>
                            <li>
                                <p>You will not upload viruses or other malicious code or otherwise compromise the
                                    security of
                                    the
                                    Services.</p>
                            </li>
                            <li>
                                <p>You will not attempt to circumvent any content-filtering techniques we employ, or
                                    attempt to
                                    access areas
                                    or features of the Services that you are not authorized to access.</p>
                            </li>
                            <li>
                                <p>You will not probe, scan, or test the vulnerability of our Services or any system or
                                    network.</p>
                            </li>
                            <li>
                                <p>You will not encourage or promote any activity that violates these Terms.</p>
                            </li>
                        </ol>
                        <p>We also care about your safety while using our Services. So do not use our Services in a way
                            that
                            would
                            distract You from obeying traffic or safety laws.</p>
                        <p><strong>Third-Party Services</strong></p>
                        <p>If you use a service, feature, or functionality that is operated by a third party and made
                            available
                            through
                            our Services (including Services we jointly offer with the third party), each party’s terms
                            will
                            govern the
                            respective party’s relationship with you. MID is not responsible or liable for a third
                            party’s terms
                            or actions
                            taken under the third party’s terms.</p>
                        <p><strong>Modifying the Services and Termination</strong></p>
                        <p>We’re relentlessly improving our Services and creating new ones all the time. That means we
                            may add
                            or remove
                            features, products, or functionalities, and we may also suspend or stop the Services
                            altogether. We
                            may take any
                            of these actions at any time, and when we do, we may not provide you with any notice
                            beforehand.</p>
                        <p>While we hope you remain a lifelong MID member, you can terminate these Terms at any time and
                            for any
                            reason by
                            deleting your account.</p>
                        <p>MID may also terminate these Terms with you at any time, for any reason, and without advanced
                            notice.
                            That
                            means that we may stop providing you with any Services, or impose new or additional limits
                            on your
                            ability to
                            use our Services. For example, we may deactivate your account due to prolonged inactivity,
                            and we
                            may reclaim
                            your username at any time for any reason.</p>
                        <p><strong>Indemnity</strong></p>
                        <p>You agree, to the extent permitted by law, to indemnify, defend, and hold harmless MID, our
                            Affiliates,
                            directors, officers, stockholders, employees, representatives, consultants, advisors,
                            licensors, and
                            agents from
                            and against any and all complaints, charges, claims, damages, losses, costs, liabilities,
                            and
                            expenses
                            (including attorneys’ fees) due to, arising out of, or relating in any way to:</p>
                        <ol>
                            <li>
                                <p>Your access to or use of the Services;</p>
                            </li>
                            <li>
                                <p>Your content; and</p>
                            </li>
                            <li>
                                <p>Your breach of these Terms.</p>
                            </li>
                        </ol>
                        <p><strong>Disclaimers</strong></p>
                        <p>We try to keep the Services up and running and free of annoyances. But we make no promises
                            that we
                            will
                            succeed.</p>
                        <p>The Services are provided “as is” and “as available” and to the extent permitted by law
                            without
                            warranties of
                            any kind, either express or implied, including, but not limited to, implied warranties of
                            merchantability,
                            fitness for a particular purpose, title, and non infringement. In addition, while MID
                            attempts to
                            provide a good
                            user experience, we do not represent or warrant that:</p>
                        <ol>
                            <li>
                                <p>The Services will always be secure, error-free, or timely;</p>
                            </li>
                            <li>
                                <p>The Services will always function without delays, disruptions, or imperfections;
                                    or</p>
                            </li>
                            <li>
                                <p>That any content, user content, or information you obtain on or through the Services
                                    will be
                                    timely or
                                    accurate.</p>
                            </li>
                        </ol>
                        <p>MID takes no responsibility and assumes no liabilities for any content that you, another
                            user, or a
                            third party
                            creates, uploads, posts, sends, receives, or stores on or through our services. You
                            understand and
                            agree that
                            you may be exposed to content that might be offensive, illegal, misleading, or otherwise
                            inappropriate; none of
                            which MID will be responsible for.</p>
                        <p><strong>Limitation of Liability</strong></p>
                        <p>To the maximum extent permitted by law, MID and our managing members, shareholders,
                            employees,
                            Affiliates,
                            licensors, consultants, advisors, agents, representatives and suppliers will not be liable
                            for any
                            indirect,
                            incidental, special, consequential, punitive, or multiple damages, or any loss of profits or
                            revenues, whether
                            incurred directly or indirectly, or any loss of data, use, goodwill, or other intangible
                            losses,
                            resulting
                            from:</p>
                        <ol>
                            <li>
                                <p>your access to or use of or inability to access or use the Services;</p>
                            </li>
                            <li>
                                <p>the conduct or content of other users or third parties on or through the Services;
                                    or</p>
                            </li>
                            <li>
                                <p>unauthorized access, use, or alteration of your content, even if MID has been advised
                                    of the
                                    possibility of
                                    such damages.</p>
                            </li>
                        </ol>
                        <p>In no event will MID’s aggregate liability for all claims relating to the Services shall
                            exceed the
                            amount you
                            paid MID (excluding for charitable purposes), if any, in the last 12 months.</p>
                        <p><strong>Arbitration, Class-Action Waiver, and Jury Waiver</strong></p>
                        <p>PLEASE READ THE FOLLOWING PARAGRAPHS CAREFULLY BECAUSE THEY REQUIRE YOU AND MID TO AGREE TO
                            RESOLVE
                            ALL
                            DISPUTES BETWEEN US THROUGH BINDING INDIVIDUAL ARBITRATION.</p>
                        <ol>
                            <li>
                                <p>Applicability of Arbitration Agreement. You and MID agree that all claims and
                                    disputes
                                    (whether contract,
                                    tort, or otherwise), including all statutory claims and disputes, arising out of or
                                    relating
                                    to these Terms
                                    or the use of the Services will be resolved by binding arbitration on an individual
                                    basis,
                                    except that you
                                    and MID. are not required to arbitrate any dispute in which either party seeks
                                    equitable
                                    relief for the
                                    alleged unlawful use of copyrights, trademarks, trade names, logos, trade secrets,
                                    or
                                    patents. To be clear:
                                    The phrase “all claims and disputes” also includes claims and disputes that arose
                                    between us
                                    before the
                                    effective date of these Terms.</p>
                            </li>
                            <li>
                                <p>Arbitration Rules. The [Indian] Arbitration and Conciliation Act, 1996 governs the
                                    interpretation and
                                    enforcement of this dispute-resolution provision. Any judgment on the award rendered
                                    by the
                                    arbitrator may
                                    be entered in any court of competent jurisdiction.</p>
                            </li>
                            <li>
                                <p>Additional Rules for Non-appearance Arbitration. If non-appearance arbitration is
                                    elected,
                                    the arbitration
                                    will be conducted by telephone, online, written submissions, or any combination of
                                    the
                                    three; the specific
                                    manner will be chosen by the party initiating the arbitration. The arbitration will
                                    not
                                    involve any personal
                                    appearance by the parties or witnesses unless the parties mutually agree
                                    otherwise.</p>
                            </li>
                            <li>
                                <p>Authority of the Arbitrator. The seat of arbitration shall be Mumbai, Maharashtra,
                                    India and
                                    the courts of
                                    Mumbai shall have exclusive jurisdiction on the matters contained herein. The
                                    dispute will
                                    not be
                                    consolidated with any other matters or joined with any other cases or parties. The
                                    arbitrator will have the
                                    authority to grant motions dispositive of all or part of any claim or dispute. The
                                    arbitrator will have the
                                    authority to award monetary damages and to grant any non-monetary remedy or relief
                                    available
                                    to an
                                    individual under law, the arbitral forum’s rules, and the Terms. The arbitrator will
                                    issue a
                                    written award
                                    and statement of decision describing the essential findings and conclusions on which
                                    the
                                    award is based,
                                    including the calculation of any damages awarded. The arbitrator has the same
                                    authority to
                                    award relief on
                                    an individual basis that a judge in a court of law would have. The award of the
                                    arbitrator
                                    is final and
                                    binding upon you and MID.</p>
                            </li>
                            <li>
                                <p>Waiver of Jury Trial. You and MID waive any constitutional and statutory rights to go
                                    to
                                    court and have a
                                    trial in front of a judge or a jury. You and MID are instead electing to have claims
                                    and
                                    disputes resolved
                                    by arbitration. Arbitration procedures are typically more limited, more efficient,
                                    and less
                                    costly than
                                    rules applicable in court and are subject to very limited review by a court. In any
                                    litigation between you
                                    and MID over whether to vacate or enforce arbitration award, you and MID waive all
                                    rights to
                                    a jury trial,
                                    and elect instead to have the dispute be resolved by a judge.</p>
                            </li>
                            <li>
                                <p>Waiver of Class or Consolidated Actions. All claims and disputes within the scope of
                                    this
                                    arbitration
                                    agreement must be arbitrated or litigated on an individual basis and not on a class
                                    basis.
                                    Claims of more
                                    than one user cannot be arbitrated or litigated jointly or consolidated with those
                                    of any
                                    other customer or
                                    user. If, however, this waiver of class or consolidated actions is deemed invalid or
                                    unenforceable, neither
                                    you nor we are entitled to arbitration; instead all claims and disputes will be
                                    resolved in
                                    a court.</p>
                            </li>
                            <li>
                                <p>Right to Waive. Any rights and limitations set forth in this arbitration agreement
                                    may be
                                    waived by the
                                    party against whom the claim is asserted. Such waiver will not waive or affect any
                                    other
                                    portion of this
                                    arbitration agreement.</p>
                            </li>
                            <li>
                                <p>Opt-out. You may opt out of this arbitration agreement. If you neither do so, neither
                                    you nor
                                    MID can force
                                    the other to arbitrate. To opt out, you must notify MID in writing no later than 15
                                    days
                                    after first
                                    becoming subject to this arbitration agreement. Your notice must include your name
                                    and
                                    address, your MID
                                    username and the email address you used to set up your MID account (if you have
                                    one), and an
                                    unequivocal
                                    statement that you want to opt out of this arbitration agreement. You must either
                                    mail your
                                    opt-out notice
                                    to our incorporated office address.</p>
                            </li>
                            <li>
                                <p>Arbitration Agreement Survival. This arbitration agreement will survive the
                                    termination of
                                    your
                                    relationship with MID.</p>
                            </li>
                        </ol>
                        <p><strong>Choice of Law</strong></p>
                        <p>The Indian laws govern these Terms and any claims and disputes (whether contract, tort, or
                            otherwise)
                            arising
                            out of or relating to these Terms or their subject matter.</p>
                        <p><strong>Final Terms</strong></p>
                        <ul>
                            <li>
                                <p>These Terms (together with any additional terms applicable to specific Services you
                                    use) make
                                    up the entire
                                    agreement between you and MID, and supersede any prior agreements.</p>
                            </li>
                            <li>
                                <p>These Terms do not create or confer any third-party beneficiary rights.</p>
                            </li>
                            <li>
                                <p>If we do not enforce a provision in these Terms, it will not be considered a
                                    waiver.</p>
                            </li>
                            <li>
                                <p>We reserve all rights not expressly granted to you.</p>
                            </li>
                            <li>
                                <p>You may not transfer any of your rights or obligations under these Terms without our
                                    consent.</p>
                            </li>
                        </ul>
                        <p>MID Support would be customer care</p>
                    </div>
                </div>
            </div>
            <AppFooter/>
        </div>);
}
